var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardDateselectIcon = function SvgNewcsDashboardDateselectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_dateselect_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M360 435h12v12h-12z",
    "data-name": "\\u77E9\\u5F62 337"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_dateselect_icon_svg__a)",
    transform: "translate(-360 -435)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M364.004 435v1.011h4V435h1v1.01h2.534a.46.46 0 0 1 .455.377l.007.082v10.074a.46.46 0 0 1-.462.458H360.46a.46.46 0 0 1-.462-.458V436.47a.46.46 0 0 1 .462-.458h2.538V435h1Zm6.994 6h-10v5h10Zm0-4h-2v1h-1v-1h-4v1h-1v-1h-2v3h10Z",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardDateselectIcon;